import useBrowserMode from './../shared/hooks/useBrowserMode';
import { KEYBE_CHAT_BOT_INTEGRATION_SRC } from './chatConstants';
interface verifyChatInterface {
   verifyChat: (chatType:string) => void;
}

const useVerifyChat = ():verifyChatInterface => {

   const { document, window } = useBrowserMode();

   const hideDefaultChat = () => {
      document.getElementById("cai-webchat")?.remove();
      document.getElementById("cai-webchat-div")?.remove();
   } 

   const showChatMentoria = () => {
      let head = document.head || document.getElementsByTagName("head")[0];
      let scriptIntegrationChat = document.createElement("script");
      scriptIntegrationChat.setAttribute("src", KEYBE_CHAT_BOT_INTEGRATION_SRC);
      head.appendChild(scriptIntegrationChat);
      let script = document.createElement("script");
      script.setAttribute("src", "" + process.env.KEYBE_CHAT_BOT_SRC);
      head.appendChild(script);
      setTimeout(() => {
         hideDefaultChat();
         var configChat = {
            apiKey: "" + process.env.KEYBE_CHAT_BOT_API_KEY
         }
         window.keybe.webchatConversationsUiLoad(configChat); 
      }, 1500);
   }

   const verifyChat = (typeChat:string) => {
      switch (typeChat) {
         case "chatMentoria":
               showChatMentoria();
               break;
         default: break;
      }
   } 

   return { verifyChat };

}

export default useVerifyChat;
